import React from "react";
import ProductCard, { ProductCardSkeleton } from "./ProductCard";

/**
 * Responsive product grid. `variant="rail"` renders a horizontally scrollable
 * row on small screens (used by homepage sections) and a grid on desktop.
 */
function ProductGrid({
  products = [],
  loading = false,
  skeletonCount = 8,
  layout = "grid",
  variant = "grid",
  priorityCount = 0,
  label,
}) {
  const className = `v-grid v-grid--${variant} v-grid--${layout}`;

  if (loading) {
    return (
      <div className={className} aria-busy="true" aria-label={label ? `Loading ${label}` : "Loading products"}>
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <ProductCardSkeleton key={index} layout={layout} />
        ))}
      </div>
    );
  }

  return (
    <ul className={className} aria-label={label}>
      {products.map((product, index) => (
        <li key={product.id || product.slug || index} className="v-grid__item">
          <ProductCard product={product} layout={layout} priority={index < priorityCount} />
        </li>
      ))}
    </ul>
  );
}

export default ProductGrid;
